import { defineComponent as _defineComponent } from 'vue'
import { twMerge } from 'tailwind-merge'

interface DropdownMenuItemProps {
  twClass?: string | string[]
}


export default /*#__PURE__*/_defineComponent({
  __name: 'DropdownMenuItem',
  props: {
    twClass: null
  },
  setup(__props: any) {



return { __sfc: true,twMerge }
}

})